export const listItemHeaderStyleLayout = {
  display: 'flex',
  height: '56px',
  minHeight: '56px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
}
export const listItemHeaderStyle = {
  display: 'flex',
  padding: '5px 24px 5px 16px',
  alignItems: 'center',
  gap: '16px',
  flex: '1 0 0',
  alignSelf: 'stretch'
}
export const listItemStyleLayout = {
  display: 'flex',
  height: '72px',
  minHeight: '72px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch'
}
export const listItemStyle = {
  display: 'flex',
  padding: '5px 24px 5px 16px',
  alignItems: 'center',
  gap: '16px',
  flex: '1 0 0',
  alignSelf: 'stretch'
}
export const listHeader1 = {
  color: 'var(--M3-sys-light-on-surface, #191C1C)',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '20px',
  letterSpacing: '0.1px',
}
export const listHeader2 = {
  color: 'var(--M3-sys-light-on-surface, #3F4949)',
  fontFamily: 'Inter',
  fontSize: '11px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.5px',
}
export const listSubHeader = {
  color: 'var(--M3-sys-light-on-surface, #191C1C)',
  // textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '20px',
  letterSpacing: ' 0.1px',
}
export const listRowItem = {
  color: 'var(--M3-sys-light-on-surface, #191C1C)',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0.5px',
}
export const listRowSubItem = {
  color: 'var(--M3-sys-light-on-surface-variant, #3F4949)',
  fontFamily: 'Inter',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.5px',
}
export const dividerLineLayout = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  alignSelf: 'stretch'
}
export const listItemTextStyle = {
  color: 'var(--M3-sys-light-on-surface-variant, #3F4949)',
  textAlign: 'right',
  fontFamily: 'Inter',
  fontSize: '11px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.5px'
}
export const fieldDisplayTextStyle = {
  color: 'var(--M3-sys-light-on-surface, #191C1C)',
  fontFamily: 'Inter',
  fontSize: '22px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '28px'
}
export const fieldDeleteTextStyle = {
  color: 'var(--M3-sys-light-error, #BA1A1A)',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0.5px'
}
export const addButtonTextStyle = {
  color: 'var(--M3-sys-light-on-primary-container, #002021)',
  textAlign: 'center',
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '24px',
  letterSpacing: '0.15px'
}